import React from 'react';
import { ITableStructureItem } from 'modules';

export const structure = (): ITableStructureItem[] => {
  return [
    {
      name: 'STT',
      key: 'stt',
    },
    {
      name: 'Loại dịch vụ',
      key: 'typeService',
    },
    {
      name: 'Mã khách hàng',
      key: 'customerCode',
    },
    {
      name: 'Tên khách hàng',
      key: 'customerName',
    },
    {
      name: 'Địa chỉ',
      key: 'address',
    },
    {
      name: 'Kỳ tháng',
      key: 'date',
    },
    {
      name: 'Số tiền',
      key: 'amount',
    },
  ];
};
